module.exports = __webpack_public_path__ + "assets/errorCorrection.ff5cf8a2.svg";